import { CIF } from '../utils/constants.json';

const INITIAL_STATE = {
  fseList: [],
  fseInfo: [],
  teamList: [{ label: 'Select Team', value: 'select' }],
  fileTypes: [],
  fileProcesses: [],
};
/**
 * @param {Object} state initial/default device state.
 * @param {Object} action to be performed
 * @return {Object} new device state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case CIF.CIF_PANEL.SUCCESS:
      return { ...state, ...payload };
    case CIF.CIF_PANEL.FAILURE:
      return { ...state, ...payload };
    default:
      return state;
  }
}
